var App = App || {};

App.mixins = {};
;App.mixins = App.mixins || {};

const EventSubscriberMixin = (superclass) => class extends (superclass || class {}) {
	_listeners = {};

	on(event, handler) {
		(this._listeners[event] ||= []).push(handler);
	}

	off(event, handler) {
		if (!this._listeners[event]) return;
		this._listeners[event] = this._listeners[event].filter(h => h !== handler);
	}

	once(event, handler) {
		const wrapper = (...args) => {
			this.off(event, wrapper);
			handler(...args);
		};
		this.on(event, wrapper);
	}

	emit(event, ...args) {
		if (!this._listeners[event]) return;
		for (const handler of this._listeners[event]) {
			handler(...args);
		}
	}
}

App.mixins.event_subscriber = EventSubscriberMixin;
;const FillableMixin = (superclass) => class extends (superclass || class {}) {
	constructor(params) {
		super();
			if (params && typeof params === 'object') Object.assign(this, params);
	}

}


;App.mixins = App.mixins || {};

/**
 * @param { { prototype: HTMLElement, new(): HTMLElement } } superclass
 */
const HasEventCallbacksMixin = (superclass) => class extends (superclass || class {}) {
	constructor() {
		super();
		for (let key in this) {
			if (key.startsWith('on') && typeof this[`bind${key}`] === 'function') {
				this.addEventListener(key.slice(2).toLowerCase(), this[`bind${key}`]);
			}
		}
	}

}

App.mixins.has_event_callbacks = HasEventCallbacksMixin
;App.mixins = App.mixins || {};

/**
 * @template {new (...args: any[]) => HTMLElement} TBase
 * @param {TBase} [superclass]
 * @returns {TBase & {
 *   new(...args: ConstructorParameters<TBase>): InstanceType<TBase> & {
 *     readonly refsContainer: HTMLElement | ShadowRoot,
 *     ref(name: string): HTMLElement | null,
 *     refs(name: string): NodeListOf<HTMLElement>,
 *   }
 * }}
 */
const HasRefsMixin = (superclass) => class extends (superclass || class {}) {

	/**
	 * @return {HTMLElement|ShadowRoot}
	 */
	get refsContainer() {
		return this.shadowRoot || this;
	}

	/**
	 * @param {string} name
	 * @return {HTMLElement|null}
	 */
	ref(name) {
		return this.refsContainer.querySelector(`[data-ref="${name}"]`);
	}

	/**
	 * @param {string} name
	 * @return {NodeListOf<Element>}
	 */
	refs(name) {
		return this.refsContainer.querySelectorAll(`[data-ref="${name}"]`);
	}
};

App.mixins.has_refs = HasRefsMixin;
;/**
 * @template {new (...args: any[]) => object} TBase
 * @param {TBase} [superclass]
 * @returns {TBase & {
 *   instance: InstanceType<TBase> | null,
 *   getInstance(...args: ConstructorParameters<TBase>): InstanceType<TBase>,
 *   destroyInstance(): void,
 * }}
 */
const SingletonMixin = (superclass) => class extends (superclass || class {}) {

	/** @type {InstanceType<typeof this> | null} */
	static instance = null;

	constructor() {
		super();
		if (Object.prototype.hasOwnProperty.call(this.constructor, 'instance') && this.constructor.instance) {
			throw new Error(
				`An instance of ${this.constructor.name} already exists. Use ${this.constructor.name}.getInstance() to access it.`
			);
		}
	}

	/**
	 * @param {...any} args
	 * @returns {InstanceType<typeof this>}
	 */
	static getInstance(...args) {
		if (!Object.prototype.hasOwnProperty.call(this, 'instance') || !this.instance) {
			this.instance = new this(...args);
		}
		return this.instance;
	}

	/** @returns {void} */
	static destroyInstance() {
		if (!Object.prototype.hasOwnProperty.call(this, 'instance')) return;
		if (typeof this.instance?.destroy === 'function') {
			this.instance.destroy();
		}
		this.instance = null;
	}
};
